/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useFormSelector } from '../../custom-hooks';
import { applyFormRules, setShouldSkipFormRulesEvaluation } from '../actions/runtime.actions';
import { ACTION_TYPE_SET_DEFAULT } from '../constants/runtime.constants';
import { FormContext } from '../context';
import {
  getEntityData,
  getFormRules,
  getPrimaryKeysMap,
  getShouldExecuteSetDefaultActions,
  getShouldSkipFormRulesEvaluation,
} from '../selectors/common.selectors';
import { getSsContext } from '../selectors/form-manager.selectors';
import { getFormsWatchValues } from '../utils/runtime.utils';

const FormRulesController = () => {
  const dispatch = useDispatch();
  const entityData = useFormSelector(getEntityData);
  const formRules = useFormSelector(getFormRules);
  const primaryKeysValues = useFormSelector(getPrimaryKeysMap);
  const ssContext = useFormSelector(getSsContext);
  const shouldExecuteSetDefaultActions = useFormSelector(getShouldExecuteSetDefaultActions);
  const shouldSkipFormRulesEvaluation = useFormSelector(getShouldSkipFormRulesEvaluation);
  const formsAreMountedRef = useRef(false);
  const formKey = useContext(FormContext);
  const [prevFormsWatchValues, setPrevFormsWatchValues] = useState([]);

  useEffect(() => {
    if (shouldSkipFormRulesEvaluation) {
      dispatch(setShouldSkipFormRulesEvaluation(false, formKey));
      return;
    }

    // run specific rules
    if (formsAreMountedRef.current) {
      const formsWatchValues = getFormsWatchValues(ssContext, primaryKeysValues);

      const formsIdsWithChangedWatchValues = Object.keys(formsWatchValues).reduce(
        (acc, formId) =>
          formsWatchValues[formId] !== prevFormsWatchValues[formId] ? [...acc, formId] : acc,
        []
      );

      setPrevFormsWatchValues(formsWatchValues);

      const rulesToExecute = formRules.filter((rule) => {
        const hasSetDefaultActions = rule.actions.some(
          ({ type }) => type === ACTION_TYPE_SET_DEFAULT
        );

        const shouldBeTriggeredByDataChanges =
          formsIdsWithChangedWatchValues.includes(rule.formId) && rule.Conditions.length;

        return (
          shouldBeTriggeredByDataChanges || (hasSetDefaultActions && shouldExecuteSetDefaultActions)
        );
      });

      dispatch(applyFormRules({ formKey, formRules: rulesToExecute }));
      return;
    }

    // run all rules
    formsAreMountedRef.current = true;
    dispatch(applyFormRules({ formKey, formRules, formsAreMountedRef }));
  }, [entityData, shouldSkipFormRulesEvaluation]);

  return <div style={{ display: 'none' }} />;
};

export default FormRulesController;
